import React, { useState, useEffect } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";

import Axios from "../api/Axios";

import {
  CheckCircleTwoTone,
  LoadingOutlined,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { setVerificationStatus } from "../store/slices/VerifyPassword";
import { useDispatch } from "react-redux";
import ImagesSlider from "../components/ImagesSlider";
import { setmessageSlice } from "../store/slices/messageSlice";
import { MAIN_LOGO_BIG } from "../ImagesSrc";
const VerifyUser = () => {
  const [verified, setVerified] = useState("Verifiying");
  const history = useNavigate();
  const dispatch = useDispatch();
  const { uid, token } = useParams();
  useEffect(() => {
    const verifyuser = async () => {
      try {
        const res = await Axios.get(`/verification/${uid}/${token}/`);
        //console.log(res.data);
        if (res.status === 204) {
          history("/");
          dispatch(setmessageSlice(true));
        } else {
          if (res.data?.detail?.is_verified) {
            setVerified("Verfied Successfully");
            dispatch(setVerificationStatus(true));
          } else {
            setVerified("Verification falied");
          }
        }
      } catch (err) {
        //console.log(err);
        setVerified("Verification falied");
      }
    };
    verifyuser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigate = () => {
    history(`/setpassword/${uid}/${token}/`);
  };
  return (
    <div className="main-co">
      <div className="cont" style={{ height: "56rem" }}>
        <div className="left">
          <img
            alt=""
            src={MAIN_LOGO_BIG}
            className="logo1"
            height={"37px"}
            width={"150px"}
          />
          <div className="signIn_text1">User Verification</div>
          <div className="text-verfied-container">
            <div>{verified}</div>
            <div style={{ marginTop: "1rem" }}>
              {verified === "Verifiying" && <LoadingOutlined />}
              {verified === "Verfied Successfully" && (
                <CheckCircleTwoTone twoToneColor="#52c41a" />
              )}
              {verified === "Verification falied" && (
                <CloseCircleTwoTone twoToneColor="#eb2f96" />
              )}
            </div>
            {verified === "Verfied Successfully" && (
              <div style={{ marginTop: "1rem" }}>
                To set your password{" "}
                <div
                  style={{
                    color: " #295BDC",
                    cursor: "pointer",
                    marginTop: "0.6rem",
                  }}
                  onClick={navigate}
                >
                  Click here
                </div>
              </div>
            )}
          </div>
        </div>
        <ImagesSlider />
      </div>
      {/* <div className="end-text1">
        Don't have an account?{" "}
        <span
          style={{ color: " #295BDC", cursor: "pointer" }}
          onClick={navigate}
        >
          Create account
        </span>
      </div> */}
    </div>
  );
};

export default VerifyUser;
